class Panel {
	constructor( node ) {
		this.node        = node;
		this.openedClass = 'panels__panel--opened';
		this.opened      = this.node.classList.contains(this.openedClass);
		this.title       = this.node.querySelector('.panels__title');
		this.content     = this.node.querySelector('.panels__content');

		if ( this.title ) {
			this.title.addEventListener( 'click', () => this.toggle() );
		}
	}

	open() {
		this.node.classList.add( this.openedClass );
		this.title.setAttribute( 'aria-expanded','true' );

		this.content.style.display  = 'block';
		this.content.style.position = 'absolute';

		let height = this.content.offsetHeight;

		this.content.style.position = '';
		this.content.style.height   = '0px';
		this.content.style.overflow = 'hidden';

		let transitionend = (e) => {
			this.content.removeAttribute('style');
			this.opened = true;
			this.content.removeEventListener('transitionend', transitionend);

			this.node.dispatchEvent( new CustomEvent( 'panel:opened', { bubbles: true, cancelable: false } ) );
		}

		this.content.addEventListener('transitionend', transitionend);

		this.content.style.transitionProperty = 'height, opacity';
		this.content.style.transitionDuration = '300ms';
		this.content.style.transitionTimingFunction = 'cubic-bezier(0.68, -0.55, 0.265, 1.55), linear';

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.content.style.height = `${height}px`;
				this.content.style.opacity = 1;
			})
		});
	}

	close() {
		this.node.classList.remove(this.openedClass);
		this.title.setAttribute('aria-expanded','false');
		this.content.style.display = 'block';
		this.content.style.overflow = 'hidden';
		this.content.style.height = `${this.content.offsetHeight}px`;
		this.content.style.transitionProperty = 'height, opacity';
		this.content.style.transitionDuration = '300ms';
		this.content.style.transitionTimingFunction = 'cubic-bezier(0.68, -0.55, 0.265, 1.55), linear';

		let transitionend = (e) => {
			this.content.removeAttribute( 'style' );
			this.opened = false;
			this.content.removeEventListener( 'transitionend', transitionend );

			this.node.dispatchEvent( new CustomEvent( 'panel:closed', { bubbles: true, cancelable: false } ) );
		}

		this.content.addEventListener( 'transitionend', transitionend );

		requestAnimationFrame( () => {
			requestAnimationFrame( () => {
				this.content.style.height = '0';
				this.content.style.opacity = 0;
			} );
		} );
	}

	toggle() {
		return this.opened ? this.close() : this.open();
	}
}

class Panels {
	constructor(node) {
		this.node = node;
		this.node.classList.add('panels--interactive');

		this.panels       = Array.from(this.node.querySelectorAll('.panels__panel')).map(node => new Panel(node));
		this.expander     = this.node.querySelector('.panels__expand');
		this.expandText   = this.expander ? this.expander.querySelector( '.panels__expand-text--expand' ) : null;
		this.collapseText = this.expander ? this.expander.querySelector( '.panels__expand-text--collapse' ) : null;
		this.expanded     = false;

		if ( this.expander ) {
			this.expander.addEventListener('click', (e) => {
				e.preventDefault();

				this.expanded ? this.collapse() : this.expand();
			});
		}

		const onPanelToggle = () => {
			const opened = this.panels.filter( panel => panel.opened ).length;

			if ( opened === this.panels.length ) {
				this.expand();
			} else if ( 0 === opened ) {
				this.collapse();
			}
		}

		this.node.addEventListener( 'panel:opened', onPanelToggle );
		this.node.addEventListener( 'panel:closed', onPanelToggle );
	}

	collapse() {
		this.expanded = false;
		this.panels.filter( panel => panel.opened ).forEach( panel => panel.close() );

		if ( this.collapseText ) {
			this.collapseText.hidden = true;
		}

		if ( this.expandText ) {
			this.expandText.removeAttribute('hidden');
		}
	}

	expand() {
		this.expanded = true;
		this.panels.filter( panel => ! panel.opened ).forEach( panel => panel.open() );

		if ( this.expandText ) {
			this.expandText.hidden = true;
		}

		if ( this.collapseText ) {
			this.collapseText.removeAttribute('hidden');
		}
	}
}

Panels.instances = Array.from(document.querySelectorAll('.panels')).map(p => new Panels(p));

export default Panels;
